import React from 'react'
import { View } from 'styles/reactnative'

import { Button, Input, Popover, Select, Space } from 'antd'
import TableAPI from '../../../components/TableAPI'
import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { column_walletlist_page } from '../../../components/AdminUserModal/UserInfoTabs/column_walletlist_page'
import { useUserList } from '../../../hooks/user/userlist'
import { useUserGroup } from '../../../hooks/user/usergroups'
import SettingGroup from 'app/adminpages/AdminSystem/SettingGroup'

const AdminWalletList = ({ title, type }: any) => {
	const queryParams = new URLSearchParams(window.location.search)
	const id = queryParams.get('userid')

	const [search, setSearch] = React.useState(id || '')
	const [wallettype, setWalletType] = React.useState('9')

	const { usertype1 } = useUserList()
	const [group, setGroup] = React.useState('*')
	const { type1 } = useUserGroup()

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<Select
					placeholder="지갑계좌"
					filterOption={true}
					options={[
						{ value: '', label: '전체' },
						{ value: '0', label: '코인현물' },
						{ value: '1', label: '코인선물' },
						{ value: '9', label: '글로벌예수금' },
					]}
					value={wallettype}
					onChange={value => {
						setWalletType(value)
					}}
					style={{ width: 150, marginRight: 10 }}
				/>

				<Space.Compact direction="horizontal">
					<SettingGroup
						title={'그룹설정'}
						group={group}
						setGroup={setGroup}
						defaultv="*"
					/>
					<Popover
						placement="bottom"
						trigger={'click'}
						content={
							<Space style={{ alignItems: 'center' }}>
								<Select
									style={{ width: '100%', minWidth: 200 }}
									defaultValue={''}
									onChange={e => {
										setSearch(e)
									}}
									options={[
										{ value: '', label: '전체' },
										...(usertype1 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder="회원코드"
							value={search}
							onChange={e => {
								setSearch(e.target.value)
							}}
						/>
					</Popover>
					<Button
						onClick={() => {
							setSearch('')
						}}
						style={{ paddingTop: 0 }}
						size="small">
						{search ? <CloseOutlined /> : <SearchOutlined />}
					</Button>
				</Space.Compact>
			</View>
			<TableAPI
				title={title}
				columns={column_walletlist_page}
				usermodal={true}
				height={'default'}
				apikey={`/admin/walletlist?group=${group}&${
					(search ? 'userid=' + search : 't=') +
					(wallettype
						? '&type=wallet_type&searchWord=' + wallettype
						: '')
				}`}
			/>
		</View>
	)
}

export default React.memo(AdminWalletList)
